<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
        :disabled="disabled"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="800px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
      append-to-body
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :hxSkuFtyCode="editFormDialogOptions.code"
        :hxSkuCode="hxSkuCode"
        @saveReload="saveReload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from './edit-form'

export default {
  props: {
    hxSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxSkuFtyListApi({
          hxSkuCode: this.hxSkuCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    saveReload() {
      this.getData()
      this.$emit('reloadSku')
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('INDEX.dialog_title_amz_sku_fty_edit') || '编辑生产厂家',
        add: this.$l('INDEX.dialog_title_amz_sku_fty_add') || '新增生产厂家',
        detail:
          this.$l('INDEX.dialog_title_amz_sku_fty_detail') || '生产厂家详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
